<template>
  <el-dialog :visible.sync="dialogVisible" width="20%" @close="handleClose">
    <img :src="QrCodeUrl" alt="" />
    <div class="CodeMsg">
      <span v-if="codeList.communityName" class="codeItem">项目名称:{{ codeList.communityName + '(' + codeList.type + ')' }}</span>
      <span v-if="codeList.code" class="codeItem">地点编号:{{ codeList.code }}</span>
      <span v-if="codeList.name" class="codeItem">地点名称:{{ codeList.name }}</span>
      <span v-if="codeList.position" class="codeItem">地点位置:{{ codeList.position }}</span>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { baseURL } from '@/api/getFile'
import { getToken } from '@/utils/auth'
export default {
  props: {
    codeUrl: {
      type: String,
      default: '',
    },
    codeList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      QrCodeUrl: '',
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    // 提交文件
    getCodeUrl(params) {
      axios({
        url: baseURL + this.codeUrl,
        method: 'GET',
        params: { token: getToken(), height: 250, width: 250, ...params },
        responseType: 'blob',
      }).then(res => {
        if (!res.data) return this.$message.error('无二维码数据')
        if (res.data.type !== 'image/png') {
          const reader = new FileReader()
          reader.readAsText(res.data, 'utf-8')
          reader.onload = () => {
            const { errMsg } = JSON.parse(reader.result)
            this.$message.error(errMsg)
          }
          return
        }
        this.QrCodeUrl = URL.createObjectURL(res.data)
        this.dialogVisible = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.CodeMsg {
  .codeItem {
    font-size: 14px;
    color: #1d2129;
    display: block;
    padding-bottom: 8px;
  }
}
::v-deep .el-dialog__body {
  text-align: center;
  padding: 0px 0px 10px;
}
</style>
